import { render, staticRenderFns } from "./RTNavigation.vue?vue&type=template&id=7454b7e6&scoped=true&"
import script from "./RTNavigation.vue?vue&type=script&lang=js&"
export * from "./RTNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7454b7e6",
  null
  
)

export default component.exports